import { Link } from "react-router-dom";

export function WikiArticleCard({ article, compact = false }) {
  if (!article) return null;
  return (
    <Link
      data-testid={`wiki-article-card-${article.id}`}
      to={`/wiki/${article.category_slug}/${article.slug}`}
      className={`block border border-amber-900/20 bg-zinc-950/50 hover:bg-zinc-950/80 hover:border-amber-700/40 transition-colors ${compact ? "p-4" : "p-5"}`}
    >
      <div className="text-[11px] uppercase tracking-[0.24em] text-amber-500/80">{(article.subcategory || article.category_slug || "Article").replace(/-/g, " ")}</div>
      <h3 className="mt-2 font-cinzel text-lg text-amber-100">{article.title}</h3>
      {article.excerpt && <p data-testid={`wiki-article-excerpt-${article.id}`} className="mt-2 text-sm text-zinc-400 leading-relaxed">{article.excerpt}</p>}
      <div className="mt-4 text-xs uppercase tracking-[0.2em] text-zinc-500">Open article</div>
    </Link>
  );
}